import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_TASKLOGWORK,
  CREATE_TASKLOGWORK,
  FETCH_TASKLOGWORK,
  FETCH_TASKLOGWORK_LIST,
  UPDATE_TASKLOGWORK,
} from './taskLogWork.actions';
import { TaskLogWorkState } from './taskLogWork.types';
import { ITaskLogWork } from '../../models/taskLogWork.model';

const initialState: TaskLogWorkState = {
  errorMessage: '',
  item: {} as ITaskLogWork,
  items: [] as ITaskLogWork[],
  loading: false,
  totalItems: 0,
};

export default (
  state: TaskLogWorkState = initialState,
  action: AppAction,
): TaskLogWorkState => {
  switch (action.type) {
    case REQUEST(FETCH_TASKLOGWORK_LIST):
    case REQUEST(CREATE_TASKLOGWORK):
    case REQUEST(FETCH_TASKLOGWORK):
    case REQUEST(UPDATE_TASKLOGWORK):
      return { ...state, loading: true };
    case SUCCESS(FETCH_TASKLOGWORK_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_TASKLOGWORK_LIST):
    case FAILURE(CREATE_TASKLOGWORK):
    case FAILURE(FETCH_TASKLOGWORK):
    case FAILURE(UPDATE_TASKLOGWORK):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_TASKLOGWORK):
    case SUCCESS(FETCH_TASKLOGWORK):
    case SUCCESS(UPDATE_TASKLOGWORK):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_TASKLOGWORK:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
